import { gql } from '@apollo/client';

const Fragments = {
  financialProduct: gql`
    fragment financialProduct on FinancialProduct {
      productId
      productName
      productCode
      leasingTypeName
      validFrom
      validTo
      productTypeName
      description
      isActive
      stateName
    }
  `
};

export default Fragments;
